<template>
  <UApp v-bind="nuxtUiAppProps">
    <UTheme :props="nuxtUiThemeProps">
      <slot />
    </UTheme>
  </UApp>
</template>

<script setup lang="ts">
import { useFlash } from "@v/composables/useFlash";
import { nuxtUiAppProps } from "@v/helpers/nuxtUiAppProps";
import { nuxtUiThemeProps } from "@v/helpers/nuxtUiThemeProps";

useFlash();
</script>
